import React from "react";
import CAMHeader from "../../../components/Header/CAMHeader";
import CAMDrawer from "../../../components/LeftSideBar/CAMDrawer";
import InvestigatorContainer from "../../../components/contsiners/InvestigatorContainer";
import BreadcrumbNav from "../header/BreadcrumbNav";
import DropdownsBar from "../header/ProductSiteUnitSelector";
import TabsNav from "../header/TabsNav";
import Table from "./Table";
import { Box } from "@mui/material";
import MultipleInput from "../../../components/Card/MultipleInput";
import { useDispatch, useSelector } from "react-redux";
import { useState, useEffect } from "react";
import * as audit from "../../../redux/audit/actions";
import Loader from "../../../components/Loader/loader";
import Pagination from "../../../components/Pagination/index";
import "./audit.scss";
import debounce from "lodash.debounce";
import { useMemo } from "react";
import AuditFilter from "./AuditFillter";

const Index = () => {
  const dispatch = useDispatch();
  const { product, site, unitOfOperation } = useSelector(
    (state) => state.shared.productSitesUopValues || {}
  );
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(1);
  const rowData = useSelector((state) => state?.auditReducer?.rows);
  const [search, setSearch] = useState();
  const [open, setOpen] = useState();
  const [debouncedSearch, setDebouncedSearch] = useState();

  const [filters, setFilters] = useState({
    from_date: "",
    to_date: "",
    status: "",
  });

  useEffect(() => {
    // let param = {};
    // param.site_id = site?.id;
    // param.product_id = product?.id;
    // param.page = 1;
    // param.page_size = rowsPerPage;
    callgetListData(1);
  }, [dispatch, unitOfOperation, debouncedSearch]);

  const handlePageChange = (event, value) => {
    setPage(value);
    callgetListData(value);
  };

  const getAuditData = (params) => {
    dispatch(audit.getAuditList(params));
  };

  const handleDownloadAudit = (params) => {
    // dispatch(audit.getAuditList(params));
  };

  const debouncedSetValue = useMemo(
    () =>
      debounce((val) => {
        setDebouncedSearch(val);
      }, 700),
    []
  );

  const handleSearch = (e) => {
    setSearch(e.target.value);
    debouncedSetValue(e.target.value);
  };

  const callgetListData = (page) => {
    // const review_status = selectedFilters.find((item) => group2.includes(item));
    // const status = selectedFilters.find((item) => group1.includes(item));

    let params = {};
    if (debouncedSearch) params.search = debouncedSearch;
    params.page = page;
    params.page_size = rowsPerPage;
    params.site_id = site?.id;
    params.product_id = product?.id;
    // if (status) params.status = status;
    // if (review_status) params.review_status = review_status;
    getAuditData(params);
  };

  return (
    <>
      {" "}
      <CAMHeader />
      <CAMDrawer />
      <InvestigatorContainer>
        <DropdownsBar />
        <TabsNav />
        <BreadcrumbNav />
        <Box display="flex" flexDirection="column" gap={1}>
          <MultipleInput
            text={"Audit Trail"}
            buttonText={"Download"}
            onButtonClick={handleDownloadAudit}
            isButton={true}
            handleSearch={handleSearch}
            search={search}
            popupFilter={true}
            handlePopupFilter={() => setOpen(true)}
          />
          <Box width="100%" className="audit-trail-table">
            <Table data={rowData || []} />
            {rowData?.loader && <Loader />}
            <Pagination
              count={rowData?.data?.total / rowsPerPage}
              page={page}
              onChange={handlePageChange}
            />
          </Box>
        </Box>
        <AuditFilter open={open} filterValues={filters} onClose={()=>setOpen(false)} />
      </InvestigatorContainer>
    </>
  );
};

export default Index;
